import { RecentActivityDto } from "@custom-types/recentActivity"
import { Paper, Typography } from "@mui/material"
import { format } from "date-fns"
import React from "react"

type RecentActivityBlockProps = {
  item: RecentActivityDto
  type: TypeOfBlock
}

export enum TypeOfBlock {
  BASE = "base graph",
  MODEL = "multistep parametrized model",
  RUN = "sampling run",
}

const colorForType = function (typ: TypeOfBlock) {
  switch (typ) {
    case TypeOfBlock.BASE:
      return "#53baa0"
    case TypeOfBlock.MODEL:
      return "#6986b0"
    case TypeOfBlock.RUN:
      return "#F1A649"
    default:
      return "#d6002a"
  }
}

export function RecentActivityBlock({ item, type }: RecentActivityBlockProps) {
  // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
  const sk_clean = item?.orig_sk.split("#")[1].replaceAll("_", " ").replaceAll("-", " ")
  // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
  const pk_clean = item?.orig_pk.split("#")[1].replaceAll("_", " ").replaceAll("-", " ")
  const textbody =
    type != TypeOfBlock.MODEL
      ? sk_clean
      : "Model " + sk_clean?.split(" ")[0] + " based on " + pk_clean

  return (
    <Paper
      sx={{
        backgroundColor: "#FAF9F6",
        color: "black",
        borderLeft: "4px solid " + colorForType(type),
        borderRadius: "1px !important",
        "&:hover": { boxShadow: 5 },
      }}
    >
      <Typography
        variant={"body1"}
        sx={{
          textTransform: "uppercase",
          color: "gray",
          pl: 1,
          fontSize: 9,
          pr: 1,
        }}
      >
        {type.valueOf()}
      </Typography>
      <Typography
        variant={"h5"}
        sx={{
          fontWeight: 600,
          pl: 1,
          pr: 1,
          pt: 0,
        }}
      >
        {textbody}
      </Typography>
      <Typography
        variant={"body2"}
        sx={{
          pl: 1,
          pb: 2,
        }}
      >
        <span className={"author"}>{item?.creator_email}</span>
      </Typography>
      <Typography
        variant={"body2"}
        sx={{
          textTransform: "uppercase",
          color: "gray",
          pl: 1,
          fontSize: 12,
          pr: 1,
        }}
      >
        Created at
        {item?.creation_date ? format(new Date(item?.creation_date), " RRRR-LL-dd HH:mm:ss") : ""}
      </Typography>
    </Paper>
  )
}
